import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_bootstrapvue_12f4445b from 'nuxt_plugin_bootstrapvue_12f4445b' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_bugsnagclient3a607406_0844c30d from 'nuxt_plugin_bugsnagclient3a607406_0844c30d' // Source: ./bugsnag.client.3a607406.js (mode: 'client')
import nuxt_plugin_vuesocialsharingplugin_910681b6 from 'nuxt_plugin_vuesocialsharingplugin_910681b6' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_storage_b98d9972 from 'nuxt_plugin_storage_b98d9972' // Source: ./storage.js (mode: 'all')
import nuxt_plugin_googlegtag_016aafdb from 'nuxt_plugin_googlegtag_016aafdb' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_gtm_2a91b402 from 'nuxt_plugin_gtm_2a91b402' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_pluginutils_1e7d398f from 'nuxt_plugin_pluginutils_1e7d398f' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vuescrollto_772c2a5d from 'nuxt_plugin_vuescrollto_772c2a5d' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_workbox_568eec48 from 'nuxt_plugin_workbox_568eec48' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_737b6b5b from 'nuxt_plugin_metaplugin_737b6b5b' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_782310cf from 'nuxt_plugin_iconplugin_782310cf' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_datefns_6fc2afc0 from 'nuxt_plugin_datefns_6fc2afc0' // Source: ./date-fns.js (mode: 'all')
import nuxt_plugin_both_6a7eabf7 from 'nuxt_plugin_both_6a7eabf7' // Source: ../plugins/both (mode: 'all')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_vueapiquery_964c47d0 from 'nuxt_plugin_vueapiquery_964c47d0' // Source: ../plugins/vue-api-query (mode: 'all')
import nuxt_plugin_localStorage_c67911f4 from 'nuxt_plugin_localStorage_c67911f4' // Source: ../plugins/localStorage (mode: 'client')
import nuxt_plugin_client_71edc27e from 'nuxt_plugin_client_71edc27e' // Source: ../plugins/client (mode: 'client')
import nuxt_plugin_server_3c0f4b8e from 'nuxt_plugin_server_3c0f4b8e' // Source: ../plugins/server (mode: 'server')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_loaddata_8046550a from 'nuxt_plugin_loaddata_8046550a' // Source: ../plugins/load-data (mode: 'all')
import nuxt_plugin_auth_271f3cf8 from 'nuxt_plugin_auth_271f3cf8' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_auth_6a7e4e1e from 'nuxt_plugin_auth_6a7e4e1e' // Source: ../plugins/auth (mode: 'all')
import nuxt_plugin_loaduserdata_4052e13b from 'nuxt_plugin_loaduserdata_4052e13b' // Source: ../plugins/load-user-data (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Baltic Probiotics","titleTemplate":"%s | Baltic Probiotics","htmlAttrs":{"amp":false},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"hid":"fb:app_id","name":"fb:app_id","content":""}],"link":[{"rel":"preconnect","href":undefined,"crossorigin":true},{"rel":"preconnect","href":undefined,"crossorigin":true}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KJZHH9JL')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=G-HLWFT10DSW","async":true}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KJZHH9JL&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrapvue_12f4445b === 'function') {
    await nuxt_plugin_bootstrapvue_12f4445b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bugsnagclient3a607406_0844c30d === 'function') {
    await nuxt_plugin_bugsnagclient3a607406_0844c30d(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_910681b6 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_910681b6(app.context, inject)
  }

  if (typeof nuxt_plugin_storage_b98d9972 === 'function') {
    await nuxt_plugin_storage_b98d9972(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_016aafdb === 'function') {
    await nuxt_plugin_googlegtag_016aafdb(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2a91b402 === 'function') {
    await nuxt_plugin_gtm_2a91b402(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1e7d398f === 'function') {
    await nuxt_plugin_pluginutils_1e7d398f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_772c2a5d === 'function') {
    await nuxt_plugin_vuescrollto_772c2a5d(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_568eec48 === 'function') {
    await nuxt_plugin_workbox_568eec48(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_737b6b5b === 'function') {
    await nuxt_plugin_metaplugin_737b6b5b(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_782310cf === 'function') {
    await nuxt_plugin_iconplugin_782310cf(app.context, inject)
  }

  if (typeof nuxt_plugin_datefns_6fc2afc0 === 'function') {
    await nuxt_plugin_datefns_6fc2afc0(app.context, inject)
  }

  if (typeof nuxt_plugin_both_6a7eabf7 === 'function') {
    await nuxt_plugin_both_6a7eabf7(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_vueapiquery_964c47d0 === 'function') {
    await nuxt_plugin_vueapiquery_964c47d0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localStorage_c67911f4 === 'function') {
    await nuxt_plugin_localStorage_c67911f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_client_71edc27e === 'function') {
    await nuxt_plugin_client_71edc27e(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_server_3c0f4b8e === 'function') {
    await nuxt_plugin_server_3c0f4b8e(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_loaddata_8046550a === 'function') {
    await nuxt_plugin_loaddata_8046550a(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_271f3cf8 === 'function') {
    await nuxt_plugin_auth_271f3cf8(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_6a7e4e1e === 'function') {
    await nuxt_plugin_auth_6a7e4e1e(app.context, inject)
  }

  if (typeof nuxt_plugin_loaduserdata_4052e13b === 'function') {
    await nuxt_plugin_loaduserdata_4052e13b(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
